import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { trim } from 'lodash';
import { Symbols } from '../../symbols';
function jsonToFromData(data) {
    const formData = new FormData();
    const keys = Object.keys(data);
    keys.forEach(key => {
        formData.append(key, data[key]);
    });
    return formData;
}
let OpenapiApi = class OpenapiApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        // #region 套餐额度分配
        this.findPackageLimit = (params) => {
            const url = this.urls.findPackageLimit;
            return this.http.get({
                url,
                params,
            });
        };
        this.savePackageLimit = (data) => {
            const url = this.urls.savePackageLimit;
            return this.http.post({
                url,
                data,
            });
        };
        // #endregion
        // #region ContentConfigurable(门户网站数据配置)
        this.getConfigList = (data) => {
            const url = this.urls.getConfigList;
            return this.http.post({
                url,
                data,
            });
        };
        this.saveConfig = (data) => {
            const url = this.urls.saveConfig;
            return this.http.post({
                url,
                data,
            });
        };
        this.configUpload = (params) => {
            const url = this.urls.configUpload;
            const formData = jsonToFromData(params);
            return this.http.postForm({
                url,
                data: formData,
            });
        };
        this.deleteConfig = (id, type) => {
            const url = `${this.urls.deleteConfig}/${id}/${type}`;
            return this.http.delete({
                url,
            });
        };
        this.release = () => {
            const url = `${this.urls.deleteConfig}/release`;
            return this.http.put({
                url,
            });
        };
        // #endregion
        // #region 租户key管理
        this.getTenantKeyList = (companyId) => {
            const url = `${this.urls.getTenantKey}/${companyId}`;
            return this.http.get({
                url,
            });
        };
        this.getRechargeRecord = (params) => {
            const url = this.urls.getRechargeRecord;
            return this.http.get({
                url,
                params,
            });
        };
        this.getTenantDeveloper = (params) => {
            const url = this.urls.getTenantDeveloper;
            return this.http.get({
                url,
                params,
            });
        };
        this.addSolutionGroup = (data) => {
            const url = this.urls.addSolutionGroup;
            return this.http.post({
                url,
                data,
            });
        };
        this.deleteSolutionGroup = (params) => {
            const url = `${this.urls.deleteSolutionGroup}?${Object.keys(params)[0]}=${Object.values(params)[0]}`;
            return this.http.delete({
                url,
            });
        };
        this.getSolutionGroup = () => {
            const url = this.urls.getSolutionGroup;
            return this.http.get({
                url,
            });
        };
        this.createPdf = (id) => {
            const url = `${this.urls.createPdf}?documentId=${id}`;
            return this.http.post({
                url,
            });
        };
        this.uploadPdf = (data) => {
            const url = this.urls.uploadPdf;
            return this.http.post({
                url,
                data,
            });
        };
        this.updatePdfKey = (params) => {
            const url = this.urls.updatePdfKey;
            return this.http.post({
                url,
                params,
            });
        };
        // #api file maintain
        this.getPdfRecord = (params) => {
            const url = this.urls.getPdfRecord;
            return this.http.get({
                url,
                params,
            });
        };
        this.generatePdfBatch = (data) => {
            const url = this.urls.generatePdfBatch;
            return this.http.post({
                url,
                data,
            });
        };
        this.downloadPdf = (data) => {
            const url = this.urls.downloadPdf;
            return this.http.post({
                url,
                data,
            });
        };
        this.getAllApiList = () => {
            const url = this.urls.getAllApiList;
            return this.http.get({
                url,
            });
        };
        this.documentGroupList = (params) => {
            const url = this.urls.documentGroupList;
            return this.http.get({
                url,
                params,
            });
        };
        this.addVersionSubmit = (data) => {
            const url = this.urls.addVersionSubmit;
            return this.http.put({
                url,
                data,
            });
        };
    }
    getCategoriesApi() {
        const url = this.urls.getCategories;
        return this.http.get({
            url,
        });
    }
    saveCategoryApi(category) {
        const url = this.urls.saveCategory;
        return this.http.post({
            url,
            data: {
                ...category,
                name: trim(category.name),
                name_us: trim(category.name_us),
            },
        });
    }
    removeCategoryApi(params) {
        const url = this.urls.removeCategory;
        return this.http.delete({
            url,
            params,
        });
    }
    removeSubCategoryApi(params) {
        const url = this.urls.removeSubCategory;
        return this.http.delete({
            url,
            params,
        });
    }
    getWhitelistApi() {
        const url = this.urls.getWhitelist;
        return this.http.get({
            url,
        });
    }
    saveWhitelistApi(whiteListItem) {
        const url = this.urls.saveWhitelist;
        return this.http.post({
            url,
            data: whiteListItem,
        });
    }
    removeWhitelistApi(whitelistId) {
        const url = this.urls.removeWhitelistItem;
        return this.http.delete({
            url,
            params: {
                white_list_id: whitelistId,
            },
        });
    }
    async uploadSwaggerApi(file) {
        const form = new FormData();
        form.append('file', file);
        const res = await this.http.postForm({
            url: this.urls.uploadSwagger,
            data: form,
        });
        return res?.data;
    }
    async apiSaveApi(data) {
        const url = this.urls.saveApi;
        return this.http.post({
            url,
            data,
        });
    }
    async getApiListApi({ page, rows = 20, name }) {
        const url = this.urls.getApiList;
        return this.http.get({
            url,
            params: {
                page,
                rows,
                name,
            },
        });
    }
    async getWhitelistApisApi() {
        const url = this.urls.getWhitelistApi;
        return this.http.get({
            url,
        });
    }
    async removeApiApi(document) {
        const url = this.urls.removeApi;
        return this.http.delete({
            url,
            params: {
                document_id: document.document_id,
            },
        });
    }
    async setApiTagApi(document) {
        const url = this.urls.setApiTagApi;
        return this.http.post({
            url,
            data: document,
        });
    }
    publishApi() {
        return this.http.put({
            url: this.urls.publish,
            data: null,
        });
    }
    getPackagesApi() {
        const url = this.urls.getPackages;
        return this.http.get({
            url,
            params: {},
        });
    }
    getProductsApi() {
        const url = this.urls.getProducts;
        return this.http.get({
            url,
            params: {
                count: 500,
            },
        });
    }
    savePackageApi(data) {
        const url = this.urls.savePackage;
        return this.http.post({
            url,
            data,
        });
    }
    getCompanyPackages(id) {
        const url = this.urls.getCompanyPackages;
        return this.http.get({
            url,
            params: {
                id,
            },
        });
    }
    getMonthlyBill(data) {
        const url = this.urls.getMonthlyBill;
        return this.http.post({
            url,
            data,
        });
    }
    getPackageUsage(data) {
        const url = this.urls.getPackageUsage;
        return this.http.post({
            url,
            data,
        });
    }
    downloadExcelExport(data) {
        const url = this.urls.downloadExcelExport;
        return this.http.post({
            url,
            data,
        });
    }
    getCustomerRanking(data) {
        const url = this.urls.getCustomerRanking;
        return this.http.post({
            url,
            data,
        });
    }
    getCompanyList() {
        const url = this.urls.getCompanyList;
        return this.http.get({
            url,
        });
    }
    getPackageRanking(data) {
        const url = this.urls.getPackageRanking;
        return this.http.post({
            url,
            data,
        });
    }
    getAPIRanking(data) {
        const url = this.urls.getAPIRanking;
        return this.http.post({
            url,
            data,
        });
    }
    deletePdfRecord(params) {
        const url = this.urls.deletePdfRecord;
        return this.http.delete({
            url,
            params,
        });
    }
};
OpenapiApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.OpenApiHttp)),
    __param(1, inject(Symbols.OpenApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], OpenapiApi);
export { OpenapiApi };
